import PropTypes from 'prop-types'
import { VehicleGenerationModel } from '../../models/vehicle/vehicle-generation-model'
import { idPropType } from '../common/id-prop-type'

const { DESCRIPTION, GENERATION_ID, GENERATION_NO, MAKE, VERSION } = VehicleGenerationModel

/**
 * @typedef {Object} VehicleGeneration
 * @property {string} [description] - The vehicle's generation description
 * @property {Id} [generationId] - The ID of the car generation
 * @property {string} [generationNo] - The vehicle's generation number
 * @property {string} [make] - The vehicle's make
 * @property {string} [version] - The vehicle's generation version
 */
export const vehicleGenerationPropType = PropTypes.shape({
    [DESCRIPTION]: PropTypes.string,
    [GENERATION_ID]: idPropType,
    [GENERATION_NO]: PropTypes.string,
    [MAKE]: PropTypes.string,
    [VERSION]: PropTypes.string
})
